import { Box, Button, Divider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <>
      <Typography variant="h5">Unauthorized</Typography>
      <Divider />
      <Typography variant="body1">
        You do not have access to the requested report.
      </Typography>
      <Box className="flexGrow">
        <Button color="black" variant="contained" onClick={goBack}>
          Go Back
        </Button>
      </Box>
    </>
  );
};

export default Unauthorized;
